import React from 'react'
import { CefrLevelCode, LanguageCode } from 'src/types'
import { Box, Grid, Flex } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import styled from 'styled-components'
import CEFRSeal from 'src/components/CEFRSeal/CEFRSeal'
import Flag from 'src/components/Flag/Flag'
import { getLanguageName } from 'lib/util'

export type Props = {
  levelCode: CefrLevelCode
  label: string
  description: string
  languageCode: LanguageCode
}

const StyledText = styled(Box)`
  a,
  a:hover,
  a:focus,
  a:active {
    color: ${(props) => props.theme.colors.blue42};
  }
`

const CEFRLevelExplanation: React.FC<Props> = ({
  levelCode,
  label,
  description,
  languageCode,
}) => {
  return (
    <Grid
      gap="2x"
      pb="2x"
      borderBottomStyle="solid"
      borderBottomWidth="small"
      borderBottomColor="gray80"
    >
      <StyledText
        variant="text.h5"
        dangerouslySetInnerHTML={{
          __html: `<p>${t(
            'You are working towards <a href="https://blog.chatterbug.com/en/how-to-talk-about-language-learning/" target="_blank" rel="noopener">CEFR Level</a>:'
          )}</p>`,
        }}
      />
      <Grid gridTemplateColumns="auto 1fr" gap="2x" alignItems="center">
        <Box width="55px" position="relative">
          <Box as="span" width="48px" display="inline-block">
            <CEFRSeal progress={1} cefrLevel={levelCode} />
          </Box>
          <Flex as="span" position="absolute" top="0" right="0">
            <Flag countryCode={languageCode} size="middle" aria-hidden="true" />
          </Flex>
        </Box>
        <Grid as="p" gap="0">
          <Box as="span" variant="text.buttonTitle">
            {getLanguageName(languageCode)}
          </Box>
          <Box
            as="span"
            variant="text.h4"
          >{`${levelCode?.toUpperCase()} ${label}`}</Box>
        </Grid>
      </Grid>
      <Box as="p" color="gray46" maxWidth="480px">
        {description}
      </Box>
    </Grid>
  )
}

export default CEFRLevelExplanation
